export default __webpack_public_path__ + "static/media/profile_banner.104cc920.png";